module.exports = __webpack_public_path__ + "static/img/1.a6cfe88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R142B/1.jpg
// module id = LzmU
// module chunks = 1